import { Loader2 } from "lucide-react";

const LoadingState = ({ message = "Loading...", fullScreen = false }) => {
    return (
        <div className={`flex w-full items-center justify-center ${fullScreen ? "h-screen" : "min-h-[75vh]"}`}>
            <div className="flex flex-col items-center justify-center">
                <Loader2 className="h-12 w-12 animate-spin text-primary" />
                <p className="mt-3 text-base font-medium text-slate-600">{message}</p>
            </div>
        </div>
    );
};

export default LoadingState;
